function setProductCheckout (event_name) {

	if (window.utag && window.utag_data) {

		// remove list_type
		const { list_type, ...restTag } = window.utag_data;
		// combine event props with utag data
		const data = {
			...restTag,
			event_name,
			gua_non_interaction: 0
		};

		// Items were added to the cart and we have tag data
		// then track 'add to cart' event and redirect to cart.
		const utagTrackingPromise = new Promise((resolve) => {

			// utag.link() returns true, or undefined if tracking is blocked
			const wasSuccessful = window.utag.link(data, () => resolve());
			if (wasSuccessful) resolve();
			// Tracking is allowed 500ms for successful resolution,
			// then we redirect to the cart regardless.
			setTimeout(() => resolve(), 500);

		});

	}

}

export default setProductCheckout;
